/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Physio_LongInputs */

const en_for_whom_physio_long = /** @type {(inputs: For_Whom_Physio_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookings and packs for visits, a home exercise routine as a plan in the app, and the recovery your client shares with you from the start.`)
};

const pl_for_whom_physio_long = /** @type {(inputs: For_Whom_Physio_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje i karnety na wizyty, zestaw ćwiczeń do domu jako plan w aplikacji i regeneracja, którą podopieczny udostępnia Ci od razu.`)
};

/**
* | output |
* | --- |
* | "Bookings and packs for visits, a home exercise routine as a plan in the app, and the recovery your client shares with you from the start." |
*
* @param {For_Whom_Physio_LongInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_physio_long = /** @type {((inputs?: For_Whom_Physio_LongInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Physio_LongInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_physio_long(inputs)
	return en_for_whom_physio_long(inputs)
});